import {
  fieldBusinessConnectVulcan,
  fieldBusinessTypeVulcan
} from '../../utils/constant';

const additionalCustomerInformationHelpers = ({
  fieldName,
  formFields,
  orderData
}) => {
  // if (fieldName === fieldBusinessTypeVulcan) {
  //   if (orderData.addProductVulcan.includes(fieldBusinessConnectVulcan)) {
  //     formFields[fieldBusinessTypeVulcan].isRequired = false;
  //     return true;
  //   } else {
  //     formFields[fieldBusinessTypeVulcan].isRequired = true;
  //   }
  // }
};

export default additionalCustomerInformationHelpers;
